import { Phone } from 'lucide-react';
import { PHONES } from '../../lib/site';

const STYLES = {
  financial: 'bg-orange-500 hover:bg-orange-600 text-white shadow-[0_10px_30px_-10px_rgba(249,115,22,0.7)]',
  medicare: 'bg-blue-600 hover:bg-blue-500 text-white shadow-[0_10px_30px_-10px_rgba(37,99,235,0.8)]',
};

export const PhoneButton = ({ type, testid, size = 'md', showLabel = true }) => {
  const p = PHONES[type];
  const pad = size === 'lg' ? 'px-7 py-4 text-base' : 'px-4 py-2.5 text-sm';
  return (
    <a
      href={p.tel}
      data-testid={testid}
      className={`inline-flex items-center justify-center gap-2 rounded-full font-semibold hover:-translate-y-0.5 ${pad} ${STYLES[type]}`}
    >
      <Phone className={size === 'lg' ? 'w-5 h-5' : 'w-4 h-4'} />
      {showLabel && <span className="opacity-80 font-medium">{p.label}</span>}
      <span>{p.display}</span>
    </a>
  );
};
